<template>
  <div>
    <v-layout row>
      <v-flex xs12>
        <v-toolbar dense flat>
          <v-text-field
            v-model="search"
            prepend-icon="search"
            label="Search"
            single-line
            hide-details
            style="padding:0;"
          ></v-text-field>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-data-table
      :search="search"
      :headers="headers"
      :items="product_edit_list"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ props.item.product_code }}</td>
        <td style="padding:6px 0 0 0;">
          <img
            :src="props.item.product_image"
            width="120px"
            height="120px"
            style="object-fit:cover;"
          />
        </td>
        <td class="text-xs-center">{{ props.item.product_name_th }}</td>
        <td class="text-xs-center">{{ props.item.product_name_en }}</td>
        <td class="text-xs-center">{{ props.item.product_sale_price }}</td>
        <td class="text-xs-center">{{ props.item.product_base_price }}</td>
        <td
          class="text-xs-center"
        >{{ props.item.product_approve == 0 ? 'New product' : 'Old product' }}</td>
        <td class="text-xs-center">
          <v-tooltip top>
            <v-btn icon @click="showDetail(props.item)" slot="activator">
              <v-icon small>remove_red_eye</v-icon>
            </v-btn>
            <span>View</span>
          </v-tooltip>
        </td>
      </template>
      <template slot="no-data"></template>
    </v-data-table>
    <ProductApproveDialog
      :selectedProvince="selectedProvince"
      :productName="productName"
      :isLoadingProductDetail="isLoadingProductDetail"
      @setDialog="productDetailDialog = $event"
      :dialog="productDetailDialog"
    />
  </div>
</template>

<script>
import ProductApproveDialog from "./ProductApproveDialog.vue";
import { mapState, mapGetters } from "vuex";
export default {
  props: ["selectedProvince"],
  data: () => ({
    productName: "",
    productDetailDialog: false,
    search: "",
    isLoadingProductDetail: false,
    color: {
      color_approve_btn: "green",
    },
    pagination: { rowsPerPage: 10 },
    headers: [
      {
        text: "Product Code",
        align: "center",
        sortable: false,
        value: "product_code",
      },
      {
        text: "Image",
        align: "center",
        sortable: false,
        value: "img",
      },
      {
        text: "Product Name Th",
        align: "center",
        sortable: false,
        value: "product_name_th",
      },
      {
        text: "Product Name EN",
        align: "center",
        sortable: false,
        value: "product_name_en",
      },
      {
        text: "Sale Price",
        align: "center",
        sortable: false,
        value: "product_pos_sale_price",
      },
      {
        text: "Base Price",
        align: "center",
        sortable: false,
        value: "product_pos_base_price",
      },
      {
        text: "New/Old product",
        align: "center",
        sortable: false,
        value: "product_approve",
      },
      {
        text: "Actions",
        align: "center",
        sortable: false,
        value: "action",
      },
    ],
  }),
  components: {
    ProductApproveDialog,
  },
  computed: {
    ...mapState({
      product_edit_list: (state) =>
        state.fetchProductApproveBack.product_edit_list,
    }),
    ...mapGetters(["isEditProductApprove"]),
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
  },
  watch: {},
  created() {},
  methods: {
    async showDetail(item) {
      console.log(item);
      this.productName = item.product_name_th;
      let configPath = {
        province: this.selectedProvince,
        productID: item.product_id,
        productApprove: item.product_approve,
      };
      this.productDetailDialog = true;
      this.isLoadingProductDetail = true;
      await this.$store.dispatch(
        "fetchProductApproveBack/getProductApproveDetail",
        configPath
      );
      this.isLoadingProductDetail = false;
    },
  },
};
</script>
<style>
.approve-btn {
  font-size: 13px;
  background-color: green;
  padding: 5px;
  border-radius: 3px;
  color: white;
  margin: 5px;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.19);
}
</style>


